import { render, staticRenderFns } from "./_labelModal.vue?vue&type=template&id=79b4bd2c&"
import script from "./_labelModal.vue?vue&type=script&lang=js&"
export * from "./_labelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports